import { getaboutList,getButtonConnection,getConnection,getOperation } from "@/api/aboutUs"

const state = {
    aboutList:[],
    informationBar:{},
    connection:[]
}
const mutations = {
   
    GETBUTTONCONNECTION(state,value){
        state.informationBar = value
    },
   
}
const actions = {
 
    async getButtonConnection({commit}){
        let result = await getButtonConnection()
        if(result.code == 200){
        commit('GETBUTTONCONNECTION',JSON.parse(result.data.attr))
        }
    },
    



}
const getters = {}
export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
}